import { jsx as _jsx } from "react/jsx-runtime";
const NoContentFound = () => {
    return (_jsx("div", { className: "mt-8 flex justify-center", children: _jsx("span", { className: "text-2xl font-medium text-gray-700", children: "Pagina heeft momenteel nog geen content" }) }));
};
export default NoContentFound;
//# sourceMappingURL=NoContentFound.js.map